import ModalCustomAudiences from "../../../../components/Modal/ModalCustomAudiences/ModalCustomAudiences";
import { LINKEDIN } from "../../../../utils/constants";

const ModalCustomAudiencesLinkedin = ({
  modalOpen,
  onCloseModal = () => {},
  integrationID,
  adAccountID,
  filteredCustomAudiences = [],
  onCallbackSave = () => {},
  preValidationCallbackSave = async () => true,
  isExcludedAudiences = false,
}) => {
  return (
    <ModalCustomAudiences
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      platform={LINKEDIN}
      isExcludedAudiences={isExcludedAudiences}
      adAccountID={adAccountID}
      integrationID={integrationID}
      filteredCustomAudiences={filteredCustomAudiences}
      onCallbackSave={async (customAudiences) => {
        const isValid = await preValidationCallbackSave();
        if (!isValid) return;
        onCallbackSave(customAudiences);
      }}
    />
  );
};

export default ModalCustomAudiencesLinkedin;
